<div class="container py-5 text-center" *ngIf="started || submissionError">
  <ng-container *ngIf="!submissionError; else submissionFailed">
    <i class="fa fa-spinner fa-spin fa-lg"></i>
    <h2 class="mt-3" translate>PUNCHOUT_SUBMITTING_TO_PROCUREMENT</h2>
  </ng-container>
  <ng-template #submissionFailed>
    <div class="alert alert-danger" role="alert">
      <span translate>PUNCHOUT_SUBMIT_FAILED</span>
      <small *ngIf="submissionFailureCode" class="d-block mt-2">{{ submissionFailureCode }}</small>
    </div>
  </ng-template>
</div>

<form
  *ngIf="payload"
  #punchoutForm
  id="punchoutForm"
  class="d-none"
  [action]="hookUrl"
  [target]="target"
  method="post"
>
  <input
    *ngFor="let field of fieldEntries"
    type="hidden"
    [name]="field.name"
    [value]="field.value"
  />
</form>
